<div
  *transloco="let t; read: 'calculated-field-config-modal'"
  class="xi-modal__container calculated-field-config-modal__container"
>
  <h1 class="xi-modal__title kxi-text-xlarge">
    {{ t('title') }}
  </h1>

  <div class="xi-modal__content">
    @if (isLoading) {
      <div class="xi-loader-container__center">
        <xi-animation
          [width]="300"
          [height]="300"
          [loop]="true"
          animation="cx_loader"
        ></xi-animation>
      </div>
    } @else {
      @if (!hasFields) {
        <span class="calculated-field-config-modal__no-fields">{{
          t('no-calculated-fields')
        }}</span>
      } @else {
        <form [formGroup]="form" class="calculated-field-config-modal__form">
          <ul formArrayName="fields" class="calculated-field-config-modal__field-list">
            @for (field of fields.controls; track field) {
              <li class="calculated-field-config-modal__field-list-item">
                <ng-container [formGroup]="field">
                  <xi-checkbox
                    color="CX"
                    formControlName="select"
                    [label]="field.controls.label.value"
                  >
                  </xi-checkbox>
                </ng-container>
              </li>
            }
          </ul>
        </form>
      }
    }
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      [text]="t('ok')"
      [disabled]="isUpdating"
      (onClick)="onOk()"
    ></xi-default-button>
  </div>
</div>
